import { Folder, Search, Keyboard, Users, Zap, Shield } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";

const Features = () => {
  const { t } = useLanguage();

  const features = [
    {
      icon: Folder,
      title: t('localRoute', 'feature1Title'),
      description: t('localRoute', 'feature1Desc'),
    },
    {
      icon: Search,
      title: t('localRoute', 'feature2Title'),
      description: t('localRoute', 'feature2Desc'),
    },
    {
      icon: Keyboard,
      title: t('localRoute', 'feature3Title'),
      description: t('localRoute', 'feature3Desc'),
    },
    {
      icon: Users,
      title: t('localRoute', 'feature4Title'),
      description: t('localRoute', 'feature4Desc'),
    },
    {
      icon: Zap,
      title: t('localRoute', 'feature5Title'),
      description: t('localRoute', 'feature5Desc'),
    },
    {
      icon: Shield,
      title: t('localRoute', 'feature6Title'),
      description: t('localRoute', 'feature6Desc'),
    }
  ];

  return (
    <section id="features" className="py-24 px-6 bg-muted/30">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-semibold mb-3">
            Everything You Need to Work Faster
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Powerful features designed to streamline your workflow and save you hours every week.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="group p-6 rounded-lg bg-card border border-border hover:border-foreground/20 transition-all animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <feature.icon className="w-5 h-5" />
              </div>
              <h3 className="text-lg font-medium mb-2">{feature.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
